package com.eladfinish.bible.contest.data.common.stringResolver

import com.eladfinish.bible.contest.SharedRes
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.provider.JsStringProvider
import io.github.aakira.napier.Napier

/**
 * On Kotlin/JS moko-resources keeps the translations in JSON files it fetches over HTTP, which is
 * why `StringDesc.toLocalizedString()` is `suspend` there. [preload] fetches them once, before the
 * app is mounted (see main.kt); from then on any string resolves synchronously through [provider],
 * the way it does on Android and iOS where the translations are bundled.
 */
object WebStrings {

    var provider: JsStringProvider? = null
        private set

    suspend fun preload() {
        try {
            provider = SharedRes.strings.stringsLoader.getOrLoad()
        } catch (t: Throwable) {
            // The app still starts; StringResolver falls back to resolving string by string.
            Napier.w(tag = "WebStrings", message = "Can't preload the translations", throwable = t)
        }
    }

    fun resolveOrNull(stringDesc: StringDesc): String? {
        val loaded = provider ?: return null
        return try {
            stringDesc.toLocalizedString(loaded)
        } catch (t: Throwable) {
            Napier.w(tag = "WebStrings", message = "Can't resolve $stringDesc", throwable = t)
            null
        }
    }

    fun resolveOrEmpty(stringDesc: StringDesc): String = resolveOrNull(stringDesc).orEmpty()
}
